import { useMemo } from 'react';

import {
  GetStaticPageRoutesQuery,
  IGetStaticPageRoutesQuery,
  IStaticPageRoute,
} from 'remote/queries/static-page';
import { useSanityQuery } from 'state/graphql';

export const useStaticPageRoutes = () => {
  const { data, error, loading, refetch } = useSanityQuery<IGetStaticPageRoutesQuery>(
    GetStaticPageRoutesQuery,
    {},
    { isV2: true }
  );

  const routes = useMemo<IStaticPageRoute[]>(
    () => (data && data.allStaticPage ? data.allStaticPage : []),
    [data]
  );

  return { error, loading, refetch, routes };
};
